import { useQuery } from "@tanstack/react-query";
import { useTRPC } from "@/trpc";
import type { RouterOutputs } from "@/trpc";

export type AdHocEntryBusinessUnit =
  RouterOutputs["timeEntry"]["getAdHocEntryBusinessUnits"][number];

/** Business units where the provider is hired, i.e. where hours can be added. */
export function useAdHocEntryBusinessUnits() {
  const trpc = useTRPC();

  const { data, isLoading } = useQuery(
    trpc.timeEntry.getAdHocEntryBusinessUnits.queryOptions(),
  );

  return { businessUnits: data ?? [], isLoading };
}
